<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      transition="dialog-bottom-transition"
      max-width="600"
      v-if="isDataLoadedFromServer"
    >
      <!--begin::Modal dialog-->
      <div class="bg-white poppins">
        <!--begin::Modal header-->
        <div class="modal-header py-4 align-center">
          <h4 class="mb-0 font-weight-bolder">Add New App</h4>
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="dialog = false"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
          <!--begin::Body-->

          <div class="h-75px">
            <v-text-field
              v-model="formData.name"
              label="Name"
              required
              clearable
              outlined
              dense
              :error-messages="nameErrors"
              @input="$v.formData.name.$touch()"
              @blur="$v.formData.name.$touch()"
            ></v-text-field>
          </div>
          <v-autocomplete
            v-model="formData.customer_id"
            :items="serverData.clients"
            outlined
            item-name="text"
            item-value="index"
            dense
            clearable
            label="Customer"
          ></v-autocomplete>
          <v-select
            v-model="formData.type"
            :items="serverData.types"
            outlined
            item-name="text"
            item-value="index"
            dense
            clearable
            label="Type"
            :error-messages="typeErrors"
            @input="$v.formData.type.$touch()"
            @blur="$v.formData.type.$touch()"
          ></v-select>
          <!--end::Body-->

          <!--begin::Actions-->
          <div class="my-4 d-flex flex-grow-1 align-end justify-center">
            <button
              type="reset"
              class="btn btn-light mr-3 px-5 py-3 ls1"
              @click="resetCreateForm"
            >
              Clear
            </button>
            <button
              type="submit"
              class="btn btn-info px-5 py-3 ls1"
              @click="submitCreateForm"
            >
              Submit
            </button>
          </div>
          <!--end::Actions-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal dialog-->
    </v-dialog>
    <TokenModal :refresh="refresher" ref="tokenModal" />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// import Swal from "sweetalert2";
import TokenModal from "@/own/components/Modals/TokenModal";

export default {
  components: { TokenModal },
  mixins: [validationMixin],
  validations: {
    formData: {
      name: { required },
      type: { required },
    },
  },
  name: "AddItem",
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
    serverData: null,
    formData: {
      name: null,
      customer_id: null,
      type: null,
    },
  }),
  beforeMount() {
    this.loadDataFromServer();
  },
  methods: {
    loadDataFromServer() {
      this.pageLoader(true);
      ApiService.post("/authorizations/apps/create")
        .then((response) => {
          this.serverData = response.data;
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      if ("email" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].email &&
          errors.push("This email address is invalid");
      }
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    toggleModal() {
      if (this.dialog) {
        this.dialog = !this.dialog;
        this.resetCreateForm();
      } else {
        this.dialog = !this.dialog;
      }
    },
    convertToFormData() {
      let data = new FormData();
      if (this.formData.customer_id) {
        data.append("customer_id", this.formData.customer_id);
      }
      if (this.formData.name) {
        data.append("name", this.formData.name);
      }
      if (this.formData.type) {
        data.append("type", this.formData.type);
      }
      return data;
    },
    submitCreateForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.pageLoader(true);
        let data = this.convertToFormData();
        ApiService.post("/authorizations/apps/store", data)
          .then((res) => {
            this.dialog = false;
            this.$refs.tokenModal.tokenDialog = true;
            this.$refs.tokenModal.tokenData = res.data.token;
            this.pageLoader(false);
          })
          .catch(() => {
            this.pageLoader(false);
          });
      }
    },
    resetCreateForm() {
      this.formData = {
        name: null,
        customer_id: null,
        type: null,
      };
    },
  },
  computed: {
    isDataLoadedFromServer: function () {
      return !!this.serverData;
    },
    nameErrors() {
      return this.handleFormValidation("name", this);
    },
    typeErrors() {
      return this.handleFormValidation("type", this);
    },
  },
};
</script>
